import { View, SafeAreaView, StatusBar, StyleSheet, ImageBackground } from 'react-native';
import HeaderSearch from '../components/HeaderSearch';
import { ParamListBase, RouteProp } from '@react-navigation/native';
import { COLORS, ROUTES } from '../constants';
import Letters from '../components/Letters';
import Timer from '../components/Timer';
import Player from '../components/Player';
import { DrawerNavigationHelpers } from '@react-navigation/drawer/lib/typescript/src/types';

export interface NavigationProps {
  route: RouteProp<ParamListBase, string>;
  navigation?: DrawerNavigationHelpers;
}

function Home (props: NavigationProps) {
  return (
    <SafeAreaView style={styles.container}>
      <StatusBar backgroundColor={COLORS.primary} />
      <HeaderSearch {...props} />
      <View style={styles.body}>
        <ImageBackground
          source={require('../assets/images/notes.png')}
          resizeMode="cover"
          imageStyle={{ opacity: 0.08 }}
          style={styles.image}>
          <Timer />
          <Letters />
          <Player />
        </ImageBackground>
      </View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: COLORS.primary,
    flex: 1,
    position: 'relative',
  },
  body: {
    flex: 1,
    backgroundColor: COLORS.background,
  },
  image: {
    flex: 1,
    justifyContent: 'center',
  },
});

export default Home;
